import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { gsap } from 'gsap';
import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { Beheaded } from '../../Beheaded';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SoundManager } from '../../config/sound/SoundManager';
import { SplashController, SplashIndex } from '../../modules/splashScreen/SplashController';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { GameData } from '../../server/data/GameData';
import { StateHandler } from '../../../core/utils/StateHandler';
import { SplashViewSFSPickAndClick } from '../../modules/splashScreen/views/SplashViewSFSPickAndClick';

export class SFSState extends StateHandler {
    public static START: string = 'start';
    public static DELAYQFX: string = 'DELAYQFX';
    public static ATTENTION: string = 'attention';
    public static RES: string = 'res';
    public static OUTRO: string = 'outro';
    public static DONE: string = 'done';
}

export class SFSPickAndClickPresentation extends Presentation {
    protected state: SFSState = new SFSState(SFSState.START);

    public setInitData(data: any): void {
        this.setGamedData(data);
    }
    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.PICKANDCLICK, data);
    }

    preStart(): void {
        this.state.set(SFSState.START);
        SplashViewSFSPickAndClick.selected = 0;
    }

    createPresentation(skip: Function): void {
        skip(false);

        switch(this.state.value){
            case SFSState.START:
                this.onStart();
                this.state.set(SFSState.DELAYQFX);
                break;
            case SFSState.DELAYQFX:
                this.timeline.to(this,{duration:0.8});
                this.state.set(SFSState.ATTENTION);
                break;
            case SFSState.ATTENTION:
                this.onAttention();
                this.state.set(SFSState.DONE);
                break;
            default:
                this.PresentationState.setInactive();
        }
    }

    onStart():void{
        this.timeline.add(Beheaded.souldWildController.soulWildRemove(), 0);

        if (Beheaded.counter.timeRemaining) {
            this.timeline.to(this, { duration: Beheaded.counter.timeRemaining });
            return;
        }

        this.timeline.add(() => {
            Beheaded.backgroundCharacter.playLevelUpSounds(0, false, false, true);

            Beheaded.soundPlayer.playSound(SoundConfig.FS_TOTAL_WIN);
            Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_LOOP);
            Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY, 0);
            Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_LOOP_SKULL, 0);

        });

        SoundManager.fadeOutAmbient(100, 0);
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        Beheaded.souldWildController.hideAllProgressionBars();
        Beheaded.baseMultiplier.setValue(1);

        this.timeline.add(() => {
            BeheadedEngineManager.RAll((reel) => {
                reel.createMoveUpDown();
            });
        })

        this.timeline.add(SplashController.instance.play(SplashIndex.PICKANDCLICK, false, false,() => {
            this.skip();
        }),"+=.5");

        if (Beheaded.apiPlugin.isReplay) {
            this.timeline.add(() => { SplashController.instance.stop(); })
        }
        else
            this.timeline.add(gsap.timeline({repeat:-1}).to(this,{duration:1}))
    }

    onAttention():void{
        if (SplashViewSFSPickAndClick.selected === 1) {
            const teaseDurr = Beheaded.backgroundCharacter.showTeaseButt().duration();
            this.timeline.to(this,{duration:teaseDurr-2 },0);
        } else if (SplashViewSFSPickAndClick.selected === 2) {
            const teaseDurr = Beheaded.backgroundCharacter.showTeaseSkull().duration();
            this.timeline.to(this,{duration:1 },0);
        }
    }


    public done(): void {
        Beheaded.apiPlugin.betHandler.pickAndClickBet(SplashViewSFSPickAndClick.selected, false)
    }
}
